import {IClampOptions} from "pixi-viewport";

/**
 * keep 0.35 difference between each scale (based on DESIGN_SCALE in floorplan-v2/app/components/Tables/Chair/types)
 * Basically the same as doing Math.round((scale / DESIGN_SCALE) * 100) / 100, which rounds to 2 decimal places
 * and applies the DESIGN_SCALE
 */
export const ZOOM_100 = 1.42;
export const ZOOM_75 = 1.07;
export const ZOOM_50 = 0.72;

export const CLAMP_SETTINGS: IClampOptions = {
  direction: 'all', underflow: "top-left"
};
